import React from "react";
import { useLocation } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";
import MainLayout from '../Layouts/MainLayout';
import { useSearch } from "../Utlis/useFetchData";
import '../CSS/SearchResults.css';
import Blogpage from '../Components/BlogCard'
const SearchResults = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search).get("q");
  const { data: searchResults, error, loading } = useSearch(query);

  const pageTitle = `Search Results for "${decodeURIComponent(query)}"`;
  return (
    <MainLayout>
      <div className="search-results-page">
        <HelmetProvider>
          <Helmet>
            <title>{pageTitle} - BlogWiki</title>
            <meta name="description" content={`Search results for "${decodeURIComponent(query)}" on BlogWiki`} />
          </Helmet>
        </HelmetProvider>
        <h1>Search Results</h1>
        {loading ? (
          <p>Loading...</p>
        ) : error ? (
          <p>Error fetching data: {error.message}</p>
        ) : (
          <div className="search-results">
            {searchResults.length === 0 ? (
              <p>No results found</p>
            ) : (
              searchResults.map((result, index) => (
                <div key={index} className="result-item">
                  <Blogpage ids={result._id} title={result.title} description={result.content} date={result.createdAt} img={result.thumbnailUrl} sector={result.Sector} author={result.author}/>
                </div>
              ))
            )}
          </div>
        )}
      </div>
    </MainLayout>
  );
};

export default SearchResults;
